/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 27/01/22
 */

import { Workplan } from '@/wpt-lib/interfaces/Workplan';
import { createUnprovisionedContext } from '@/wpt-lib/utils/contextHelpers';
import { UseStatefulRequestOutput } from '@/utils/useStatefulRequests/useStatefulRequest';
import React, { ReactNode } from 'react';

type IWorkplanContext = Pick<UseStatefulRequestOutput<Workplan>, 'loading' | 'error'> & {
    workplan: UseStatefulRequestOutput<Workplan>['responseData'];
};

export const WorkplanContext = createUnprovisionedContext<IWorkplanContext>('WorkplanContext');

type WorkplanProviderProps = { children: ReactNode } & IWorkplanContext;

export const WorkplanProvider = (props: WorkplanProviderProps) => {
    const { children, loading, workplan, error } = props;

    const context: IWorkplanContext = {
        workplan,
        error,
        loading,
    };

    return <WorkplanContext.Provider value={context}>{children}</WorkplanContext.Provider>;
};

export default WorkplanProvider;
